import { useSelector } from 'react-redux';
import { storeSidebarLinks, ownerSidebarLinks, OnlyStoreSidebarLinks, adminSidebarLinks } from '../../data/links';
import NavLink from '../ui/NavLink';
import { RootState } from '../../redux/store';
import { sidebarLink } from '../../types/sidebarLink';
import { filterSidebarLinks } from '../../utils/methods/filterSidebarLinksForAdmin';
import { useMemo } from 'react';

export const SidebarContent = () => {
  const owner = useSelector((s: RootState) => s.owner);
  const store = useSelector((s: RootState) => s.store);
  const admin = useSelector((s: RootState) => s.admin);

  const links: sidebarLink[] = useMemo(() => {
    if (owner.accessToken) {
      return [...storeSidebarLinks, ...ownerSidebarLinks];
    }
    if (!owner.accessToken && store.accessToken) {
      return [...storeSidebarLinks, ...OnlyStoreSidebarLinks];
    }
    if (admin.accessToken) {
      return filterSidebarLinks(adminSidebarLinks, admin);
    }
    return [];
  }, [owner.accessToken, store.accessToken, admin]);

  return (
    <nav className="flex flex-col gap-2 mt-10 h-[90vh] overflow-y-auto">
      <img
        src="/logo.png"
        alt="Logo"
        className="w-[162px] mb-6 ms-6 object-contain"
      />
      {links.map((item) => (
        <div key={item.title}>
          <NavLink link={item} />
        </div>
      ))}
    </nav>
  );
};
